module.exports = __webpack_public_path__ + "img/Z71_15.bdf26b19.jpg";